module.exports = __webpack_public_path__ + "img/loading-white.94a15989.svg";